import { Box, Button, Checkbox, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PostBidGeneralInfoUpdate from "./PostBidGeneralInfoUpdate";
import "./postbid-modern.css";

const AREA_NAMES = ["צפון","קרית שמונה והסביבה","חיפה והסביבה","ירושלים והסביבה","נתניה והסביבה","השרון והסביבה","מרכז","שפלה והסביבה","באר שבע והסביבה","דרום"];
const DURATIONS = [
  [0, "ללא שינוי במשך המכרז"], [0.166, "10 דקות"], [0.5, "30 דקות"], [1, "1 שעה"], [3, "3 שעות"], [6, "6 שעות"], [12, "12 שעות"],
  [24, "1 יום"], [48, "2 ימים"], [72, "3 ימים"], [96, "4 ימים"], [120, "5 ימים"], [144, "6 ימים"], [168, "7 ימים"]
];

function PostBidUpdate() {
  const { id } = useParams();
  const [time, setTime] = useState(0);
  const [title1, setTitle1] = useState("");
  const [show, setShow] = useState(false);
  const [bidData, setBidData] = useState({});
  const [next, setNext] = useState(false);
  const [validTitle, setValidTitle] = useState(false);
  const [area, setArea] = useState("");

  useEffect(() => {
    axios.get(`${process.env.React_APP_BACKEND_URL}/api/getabid?id=${id}`, {
      headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    }).then((res) => {
      const bid = res.data.Bid[0];
      setTitle1(bid.title || "");
      setArea(bid.area || "");
      setBidData(bid);
      setShow(true);
    }).catch((err) => console.log(err));
  }, [id]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (title1.trim().length < 5) { setValidTitle(true); return; }
    setValidTitle(false);
    if (!area) return;

    const date = new Date();
    bidData.title = title1.trim();
    bidData.area = area;
    if (Number(time) !== 0) {
      // Preserve the contract used by the original edit flow:
      // updateWholeBid receives the selected duration as hours, while deadline is an absolute ms timestamp.
      bidData.length = Number(time);
      bidData.deadline = date.getTime() + Number(time) * 60 * 60 * 1000;
      bidData.durationChanged = true;
    } else {
      // No duration change: preserve the values that came from the server.
      bidData.length = bidData.length1;
      bidData.deadline = bidData.deadline.toString();
      bidData.durationChanged = false;
    }
    setNext(true);
  };

  if (!show) return null;

  return (
    <div className="bidit-postbid-page">
      <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, width: { xs: "92%", sm: "85%", md: "70%" }, maxWidth: "600px", mx: "auto", px: 2 }}>
        {!next ? (
          <Box component="form" onSubmit={handleSubmit} className="bidit-form-card">
            <Box className="bidit-form-intro">
              <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>עריכת מכרז</Box>
              <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>עדכון פרטי המכרז</Typography>
              <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>עברו על הפרטים ושמרו מחדש בסיום</Typography>
            </Box>

            <Box className="bidit-field-heading">
              <Typography className="bidit-field-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>מה צריך לעשות?</Typography>
              <Typography className="bidit-field-hint" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>עדכנו את כותרת המכרז במידת הצורך</Typography>
            </Box>
            <TextField fullWidth value={title1} onChange={(e) => setTitle1(e.target.value)} margin="normal" name="title" />
            {validTitle && <Box className="bidit-inline-error">הכותרת צריכה להיות לפחות 5 תווים</Box>}

            <InputLabel sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 2 }}>איפה העבודה מתבצעת?</InputLabel>
            <Select
              fullWidth
              value={area}
              onChange={(e) => setArea(e.target.value)}
              input={<OutlinedInput />}
              MenuProps={{ PaperProps: { className: "bidit-modern-area-menu", sx: { mt: 1, borderRadius: "16px", boxShadow: "0 16px 40px rgba(20,60,95,.18)" } } }}
              sx={{ borderRadius: "14px", backgroundColor: "#fbfdff", fontFamily: "Assistant" }}
            >
              {AREA_NAMES.map((name) => (
                <MenuItem key={name} value={name} sx={{ fontFamily: "Assistant", borderRadius: "12px", gap: 1 }}>
                  <Checkbox checked={area === name} sx={{ p: .4, "&.Mui-checked": { color: "#1976d2" } }} />
                  <ListItemText primary={name} primaryTypographyProps={{ sx: { fontFamily: "Assistant", fontWeight: 800, color: "#173f62" } }} />
                </MenuItem>
              ))}
            </Select>

            <InputLabel sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 3 }}>משך המכרז</InputLabel>
            <Select fullWidth value={time} onChange={(e) => setTime(e.target.value)} sx={{ borderRadius: "14px", backgroundColor: "#fbfdff", fontFamily: "Assistant" }}>
              {DURATIONS.map(([value, label]) => <MenuItem key={value} value={value} sx={{ fontFamily: "Assistant" }}>{label}</MenuItem>)}
            </Select>

            <Button type="submit" fullWidth variant="contained" className="bidit-primary-button" sx={{ mt: 3, mb: 2, fontFamily: `${process.env.REACT_APP_FONT}` }}>
              ממשיכים לבחירת בעל מקצוע
            </Button>
          </Box>
        ) : (
          <PostBidGeneralInfoUpdate bidData={bidData} />
        )}
      </Box>
    </div>
  );
}

export default PostBidUpdate;
